<procure-card
  condensed
  [class]="rootClass"
>
  <div class="order-overlay__content">
    <div formRow>
      <procure-input-select
        label="Order By"
        bindLabel="label"
        [control]="form.controls.orderBy"
        [items]="data.orderByOptions"
        [clearable]="false"
      />
    </div>
    <div formRow>
      <procure-input-check [control]="form.controls.orderIsAscending"> Order Ascending </procure-input-check>
    </div>
    <div class="order-overlay__actions">
      <button
        class="order-overlay__reset"
        procure-button
        variant="stroked"
        (click)="reset()"
      >
        Reset
      </button>
      <button
        class="order-overlay__apply"
        procure-button
        (click)="apply()"
      >
        Apply
      </button>
    </div>
  </div>
</procure-card>
